import { Box, Grid, Typography, Button, Stack, Chip, Paper } from "@mui/material";
import logo from "../assets/logo_trans.png";
import { useNavigate } from "react-router-dom";


export default function Hero() {
  const navigate = useNavigate();


  return (
    <Box px={{ xs: 2, md: 10 }} py={12}>
      <Grid container spacing={8} alignItems="center">
        <Grid item md={6}>
          <Chip label="100% Organic & Natural" sx={{ bgcolor: "#E6EFE6" }} />

          <Typography variant="h1" mt={3}>
            Nature Your Soil,
            <br />
            <span style={{ color: "#1F4D2B" }}>Grow Your Future</span>
          </Typography>

          <Typography mt={3} color="text.secondary" maxWidth={500}>
            Premium organic vermicompost and vermiwash for sustainable agriculture.
          </Typography>

          <Stack direction="row" spacing={2} mt={5}>
            <Button variant="contained" size="large"
                onClick={() => navigate("/products")}
          >
              Explore Products
            </Button>
            <Button
              variant="contained"
              size="large"
              sx={{ bgcolor: "#D27C3A" }}
              onClick={() => navigate("/products")}
          
          >
              Get Bulk Quote
            </Button>
          </Stack>

          <Stack direction="row" spacing={6} mt={6}>
            <Stat label="100%" text="Organic" />
            <Stat label="20%" text="Off Vermiwash" />
            <Stat label="10%" text="Off Vermicompost" />
          </Stack>
        </Grid>

        {/* RIGHT CIRCLE */}
 <Grid item md={6} display="flex" justifyContent="center">
  <Paper
    sx={{
      width: { xs: 260, sm: 320, md: 360 },
      height: { xs: 260, sm: 320, md: 360 },
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "none",
      bgcolor: "#E6EFE6",
      textAlign: "center"
    }}
  >
    <Box
      component="img"
      src={logo}
      alt="RK Farm Logo"
      sx={{
        height: { xs: 200, sm: 500 },
        width: "auto",
        mb: 2
      }}
    />

    <Typography variant="h6" fontWeight={700}>
      RK Farm
    </Typography>

    <Typography color="text.secondary">
      Premium Organic Products
    </Typography>
  </Paper>
</Grid>
      </Grid>
    </Box>
  );
}

function Stat({ label, text }) {
  return (
    <Box>
      <Typography variant="h4" color="primary">
        {label}
      </Typography>
      <Typography color="text.secondary">{text}</Typography>
    </Box>
  );
}
